import { z } from 'zod';
/**
 * A person's suggestion for a page (the owner: "a button to discuss or
 * suggest … all those should go to the agent who deals with development …
 * provide the actual specs to the superadmin, and then they can be built").
 *
 * It travels as a request to Norum Tech (§18) naming the procedure
 * `page_suggestion`, whose ask is this: the page by its address and title,
 * and the person's words. Tech's agent writes it up as a spec; nothing is
 * built from it until a person decides.
 */
export const SUGGESTION_MAX = 2_000;
export const pageSuggestionAskSchema = z
    .object({
    procedure: z.literal('page_suggestion'),
    /** The page's address, as the chat's context carries it. */
    route: z.string().regex(/^\/[A-Za-z0-9/_.-]{0,200}$/),
    /** The page's title, from its help. */
    pageTitle: z.string().min(1).max(120),
    /** Which department's view it was suggested in. */
    fromDepartment: z.string().min(1).max(64),
    /** What the person would change, and why, in their words. */
    suggestion: z.string().min(10).max(SUGGESTION_MAX),
})
    .strict();
/** The parts every written-up suggestion has, in order, so the superadmin reads each the same way. */
export const SUGGESTION_SPEC_PARTS = [
    'What is asked',
    'Why it helps',
    'Where',
    'What would change',
    'How we know it works',
    'How it can be built',
    'Open questions',
];
//# sourceMappingURL=suggestions.js.map